<div>
    <section class="aarni-font w-full shadow border-b  py-[50px] mt-[80px]">
        <div class="container mx-auto px-4">
            <h1 class=" text-center md:text-start font-bold text-[32px]">
                {{ pageTitle }}
            </h1>
        </div>
    </section>

    <div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
        <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
            <aside class="w-full lg:w-1/4 space-y-4 h-[1550px] overflow-y-auto h-fit">
                <div class="border-t-8 border-orange-500">
                    <div class="bg-white shadow border border-gray-300">
                        <h2 class="text-lg font-bold p-4">International Admissions</h2>
                        <div class="">

                            <a [href]="'international-admissions/why-choose-arni'"
                               [ngClass]="{'text-white bg-blue-600 ' : pageTitle === 'Why Choose Arni'}"
                               class="flex items-center space-x-2 p-3 w-full cursor-pointer text-blue-600 border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>Why Choose Arni</span>
                            </a>
                            <a [href]="'international-admissions/program-fee'"
                               [ngClass]="{'text-white bg-blue-600 ' : pageTitle === 'International Program Fee'}"

                               class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>International Program Fee</span>
                            </a>
                            <a [href]="'international-admissions/hostel-fee'"
                               [ngClass]="{'text-white bg-blue-600 ' : pageTitle === 'International Hostel Fee'}"

                               class="flex items-center space-x-2 p-3 w-full cursor-pointer text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>International Hostel Fee</span>
                            </a>
                            <a [href]="'international-admissions/apply-form'"
                               class="flex items-center space-x-2 p-3 cursor-pointer w-full text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>How To apply</span>
                            </a>
                            <a [href]="'international-admissions/admission-rules'"
                               [ngClass]="{'text-white bg-blue-600 ' : pageTitle === 'Admission Rules'}"
                               class="flex items-center space-x-2 p-3 w-full cursor-pointer text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>Admission Rules</span>
                            </a>
                            <a [href]="'/admissions/scholarship'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Scholarship', 'text-blue-600 bg-white' : pageTitle !== 'Scholarship'}"
                               class="flex items-center space-x-2 p-3 w-full cursor-pointer text-blue-600 hover:bg-blue-400 border-b border-gray-300 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>Scholarship</span>
                            </a>
                            <a [href]="'admissions/payment-procedure'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Payment Procedure', 'text-blue-600 bg-white' : pageTitle !== 'Payment Procedure'}"
                               class="flex items-center space-x-2 p-3 w-full cursor-pointer text-blue-600 hover:bg-blue-400 border-b border-gray-300 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>Payment Procedures</span>
                            </a>
                            <a [href]="'international-admissions/faqs'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Faqs', 'text-blue-600 bg-white' : pageTitle !== 'Faqs'}"
                               class="flex items-center space-x-2 p-3 w-full cursor-pointer text-blue-600 hover:bg-blue-400 border-b border-gray-300 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>FAQ</span>
                            </a>
                            <a [href]="'/admissions/flow'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Admission Flow', 'text-blue-600 bg-white' : pageTitle !== 'Admission Flow'}"
                               class="flex items-center space-x-2 p-3 w-full cursor-pointer text-blue-600 hover:bg-blue-400 border-b border-gray-300 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>Admission Flow</span>
                            </a>

                        </div>
                    </div>
                </div>
                <h2 class="text-lg font-semibold mb-4">Quick Links</h2>
                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                    <div class="space-y-2">
                        <a href="#" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                            <span class="text-gray-700 font-medium pl-4 text-xl">Faculty</span>
                        </a>
                    </div>
                </div>
                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                    <div class="space-y-2">
                        <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                            <span class="text-gray-700 font-medium text-xl pl-4">Testimonials</span>
                        </a>
                    </div>
                </div>
                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                    <div class="space-y-2">
                        <a href="#" class="flex items-center space-x-3 p-2 rounded-lg">
                             <span
                                 class="w-16 h-16 flex items-center justify-center bg-yellow-500 text-white rounded-full">
                               <i class="fa fa-calendar text-2xl"></i>
                             </span>
                            <span class="text-gray-700 font-medium pl-4 text-xl">Job Openings</span>
                        </a>
                    </div>
                </div>
                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                    <div class="space-y-2">
                        <a href="/about/leadership/chancellor" class="flex items-center space-x-3 p-2 rounded-lg ">
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span>
                            <span class="text-gray-700 font-medium pl-4 text-xl">Leadership</span>
                        </a>
                    </div>
                </div>

                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                    <div class="space-y-2">
                        <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span>
                            <span class="text-gray-700 font-medium pl-4 text-xl">Contact Us</span>
                        </a>
                    </div>
                </div>
            </aside>

            <section class="flex-1 shadow-lg p-6 border-2 border-gray-200 rounded-lg aarni-font">
                <h1 class="text-[24px] font-semibold my-6">{{ pageTitle }}</h1>
                <div *ngIf="pageTitle === 'International Program Fee'">
                    <p class="text-gray-600 mt-6 font-semibold ">
                        Admission & Procedural Charges (Medical Check-Up, Medical Insurance, AIU equivalence assistance,
                        FRRO / Police verification / Registration / Visa Extension assistance):
                    </p>
                    <p class="text-gray-600  my-3">
                        For International students except from Nepal, Bhutan, Bangladesh and NRI's from GCC countries
                        are given below:
                    </p>
                    <p class="text-gray-600  font-semibold ">
                        First Year - USD 500
                    </p>
                    <p class="text-gray-600 font-semibold ">
                        Second Year Onwards - USD 250
                    </p>
                    <p class="text-gray-600  my-3">
                        For students from Nepal, Bhutan, Bangladesh and NRI's from GCC countries are given below:
                    </p>
                    <div class="overflow-x-auto ">
                        <table class="min-w-full divide-y divide-gray-300  border-gray-200">
                            <thead class="bg-gray-100">
                            <tr>
                                <th class="px-4 py-3 text-left text-sm font-semibold border text-gray-700">Fee Type</th>
                                <th class="px-4 py-3 text-left text-sm font-semibold border text-gray-700">Amount</th>
                            </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 text-sm text-gray-800">
                            <tr>
                                <td class="px-4 border py-3">*Admission Fee (One Time & Non-Refundable)</td>
                                <td class="px-4 border py-3">Rs. 20,000</td>
                            </tr>
                            <tr>
                                <td class="px-4 border py-3">*Examination Fee (Per Semester)</td>
                                <td class="px-4 border py-3">Rs. 6,000</td>
                            </tr>
                            <tr>
                                <td class="px-4 border py-3">*Registration Fee from Second Year Onwards (Annually)</td>
                                <td class="px-4 border py-3">Rs. 5,000</td>
                            </tr>
                            <tr>
                                <td class="px-4 border py-3">*Medical check up & Insurance Fees (Annually)</td>
                                <td class="px-4 border py-3">Rs. 10,000</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="text-orange-500 text-sm font-semibold my-3">
                        Fee Structure for Nepal, Bhutan, Bangladesh and NRI's from GCC countries:
                    </p>
                    <p class="text-gray-600  text-sm font-semibold my-3">
                        Fee structure of all programmes (excluding PhD programmes & MBBS) for students from Nepal,
                        Bhutan, Bangladesh and NRI's from GCC countries is same as the fee structure for Indian
                        students. To know more,
                        <a href="" class="text-orange-500 ">Click Here</a>
                    </p>
                    <p class="text-gray-600  text-sm  my-3">
                        <span class="font-semibold">
                            Filter courses :
                        </span>
                        Click on the following school to get a better insight of various programmes and their respective
                        fee structure.
                    </p>
                    <form [formGroup]="filterCoursesForm">
                        <div class="flex gap-4 mt-4">

                            <div class="w-1/2">
                                <select (change)="getBranches()" formControlName="course_id"
                                        class="border px-3 py-2 rounded-md shadow-sm w-full min-w-0 outline-none">
                                    <option value="" selected>Select Course</option>
                                    <option *ngFor="let course of courses" [value]="course?.id">
                                        {{ course?.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="w-1/2">
                                <select formControlName="branch_id"
                                        class="border px-3 py-2 rounded-md shadow-sm w-full min-w-0 outline-none"
                                        (change)="filterBranches()">
                                    <option value="" selected>Select Branch</option>
                                    <option *ngFor="let branch of branches"
                                            [value]="branch?.branch?.id || 'general'">{{ branch?.branch?.name || 'General' }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </form>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div *ngFor="let course of courseFee" class="w-full  overflow-hidden border rounded bg-white">
                            <div class="px-6 py-4 flex flex-col item">
                                <div class="h-[140px]">
                                    <p class="font-bold mb-2">{{ course.course_name }}</p>

                                    <div class="flex justify-between text-center">
                                        <div>
                                            <p class="text-gray-700 font-semibold ">Duration</p>
                                            <p class="text-gray-700 text-sm font-medium my-2">
                                                {{ course.duration }}
                                            </p>
                                        </div>
                                        <div>
                                            <p class="text-gray-700 font-semibold">Scholarship</p>
                                            <p class="text-gray-700 text-sm font-medium my-2">
                                                {{ course.scholarship_availability }} </p>
                                        </div>
                                        <div>
                                            <p class="text-gray-700 font-semibold">Fee per year</p>
                                            <p class="text-gray-700 text-sm font-medium my-2">
                                                {{ course.fee_per_year }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex justify-between h-1/2 mb-0">
                                    <button
                                        class="rounded-3xl px-6 py-2 transition duration-300 hover:bg-[#58CF00] font-semibold text-[#58CF00] border hover:text-white">

                                        View Detail
                                    </button>
                                    <button
                                        class="rounded-3xl px-6 py-2 transition duration-300 bg-[#58CF00] font-semibold hover:bg-white text-white border hover:text-[#58CF00]">
                                        Apply Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--
                                        <div class="mt-6 space-y-6">
                                            <div *ngFor="let course of filteredCourses" class="border rounded-lg shadow-md p-4">
                                                <div class="flex justify-between items-center mb-2">
                                                    <h2 class="text-lg font-bold">{{ course?.branch?.name || course?.course?.name }}</h2>
                                                    <div class="flex gap-4">
                                                        <button class="px-4 py-2 bg-green-600 text-white rounded-md">
                                                            <a href="/form/apply-form">Apply</a>
                                                        </button>
                                                    </div>
                                                </div>

                                                <div class="flex border-b">
                                                    <button
                                                        *ngIf="course?.result_type === 'SEMESTER'"
                                                        (click)="toggleFeeType('semester', course)"
                                                        class="px-4 py-2"
                                                        [class.bg-gray-800]="course.fee_type === 'semester'"
                                                        [class.text-white]="course.fee_type === 'semester'"
                                                        [class.rounded-t-md]="course.fee_type === 'semester'"
                                                    >
                                                        Semester Fee
                                                    </button>
                                                    <button
                                                        (click)="toggleFeeType('yearly', course)"
                                                        [ngClass]="{'bg-black text-white rounded-t-md': course?.result_type === 'YEAR'}"
                                                        class="px-4 py-2 text-gray-600"
                                                        [class.bg-gray-800]="course.fee_type === 'yearly'"
                                                        [class.text-white]="course.fee_type === 'yearly'"
                                                        [class.rounded-t-md]="course.fee_type === 'yearly'"
                                                    >
                                                        Yearly Fee
                                                    </button>
                                                </div>

                                                <div *ngIf="course.fee_type === 'semester' && course?.result_type === 'SEMESTER'"
                                                     class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                                                    <div *ngFor="let fee of course?.semester_fee">
                                                        <p class="font-semibold text-center">Semester {{ fee?.semester }}</p>
                                                        <p class="text-gray-600 font-medium text-center">₹{{ fee?.fee }}</p>
                                                    </div>
                                                </div>

                                                <div *ngIf="course.fee_type === 'yearly' || course?.result_type === 'YEAR'"
                                                     class="mt-4 text-lg grid grid-cols-2 md:grid-cols-4 gap-4 text-gray-800">
                                                    <div *ngFor="let fee of course?.fees" class="">
                                                        <p class="font-semibold text-center">Year {{ fee?.year }}</p>
                                                        <p class="text-gray-600 text-center font-medium">₹{{ fee?.total_fee }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                    -->
                    <!--
                                        <div class="px-6">
                                            <h2 class="font-semibold my-3 text-gray-500 tex">Important Information Related to Admission</h2>
                                            <ul class="list-disc">
                                                <li>
                                                    <p class="text-gray-500 text-justify my-3">
                                                    <strong>Applicants are advised to carefully read and understand</strong> all the information available on the official website of Arni University:
                                                        <a href="http://www.arni.in" target="_blank">www.arni.in</a>, along with any admission-related announcements published by the University from time to time.
                                                    </p>
                                                </li>
                                                <li>
                                                    <p class="text-gray-500 text-justify my-3">
                                                    <strong>Eligibility Criteria for International Applicants:</strong><br>
                                                    - A minimum of <strong>50% marks</strong> in the qualifying examination is required.<br>
                                                    - The applicant must have studied the <strong>relevant pre-requisite subjects</strong> for the chosen program.
                                                    </p>
                                                </li>

                                                <li>
                                                    <p class="text-gray-500 text-justify my-3">
                                                    <strong>Ph.D. Program Admission (International Students):</strong><br>
                                                    - Must hold a <strong>Master’s degree in the relevant discipline</strong> with a minimum of <strong>55% marks</strong>.<br>
                                                    - Additional eligibility requirements may be prescribed by Arni University from time to time.
                                                    <p class="text-gray-500 text-justify my-3">
                                                </li>

                                                <li>
                                                    <p class="text-gray-500 text-justify my-3">
                                                    <strong>Issuance of Offer Letter:</strong><br>
                                                    - Whether conditional or unconditional, the issuance of an offer letter or any assistance/guidance provided by the university <strong>does not guarantee admission</strong> or entitlement to any university facility.
                                                    <p class="text-gray-500 text-justify my-3">
                                                </li>
                                                <li>
                                                    <p class="text-gray-500 text-justify my-3">
                                                    <strong>Right to Modify:</strong><br>
                                                    - Arni University reserves the right to <strong>add, withdraw, or modify</strong> any program or fee structure without prior notice.<br>
                                                    - The University will not be responsible for any hardship, loss, or expense incurred by applicants due to such changes.
                                                    <p class="text-gray-500 text-justify my-3">
                                                </li>
                                                <li>
                                                    <p class="text-gray-500 text-justify my-3">
                                                    <strong>Equivalency of Qualifications:</strong><br>
                                                    - For evaluating equivalency of the qualifying examination, the University will consider qualifications recognized by the <strong>Association of Indian Universities (AIU)</strong>.<br>
                                                    - For qualifications not recognized by AIU, applicants must submit <strong>equivalency certification</strong> from the Indian High Commission/Consulate in their respective country or another applicable statutory authority.
                                                    <p class="text-gray-500 text-justify my-3">
                                                </li>
                                            </ul>
                                        </div>
                    -->
                </div>
                <div *ngIf="pageTitle === 'International Hostel Fee'">
                    <p class="text-gray-600 my-3 font-semibold mx-2">
                        Accommodation Fee for Session 2022-23
                    </p>
                    <div class="overflow-x-auto ">
                        <table class="min-w-full divide-y divide-gray-300  border-gray-200">
                            <thead class="bg-gray-100">
                            <tr>
                                <th class="px-4 py-3 text-left text-sm font-semibold border text-gray-700">Hostel
                                    Category
                                </th>
                                <th class="px-4 py-3 text-left text-sm font-semibold border text-gray-700">Annual Fee (
                                    Per Student)
                                </th>
                            </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 text-sm text-gray-800">
                            <tr>
                                <td class="px-4 border py-3">Double Sharing AC with Non-Veg Food
                                </td>
                                <td class="px-4 border py-3">USD 3800</td>
                            </tr>
                            <tr>
                                <td class="px-4 border py-3">Double Sharing Non – AC with Non-Veg Food</td>
                                <td class="px-4 border py-3">USD 2800</td>
                            </tr>
                            <tr>
                                <td class="px-4 border py-3">Double Sharing AC with Non-Veg Food (With Common
                                    Washroom)
                                </td>
                                <td class="px-4 border py-3">USD 3100</td>
                            </tr>
                            <tr>
                                <td class="px-4 border py-3">Double Sharing Non – AC with Non-Veg Food (With Common
                                    Washroom)
                                </td>
                                <td class="px-4 border py-3">USD 2300</td>
                            </tr>
                            </tbody>
                        </table>
                        <p class="text-gray-600  text-sm  mt-6 mx-2">
                            <span class="text-gray-800 font-semibold">Note 1</span>
                            A security deposit of 200 USD (Refundable) will be charged from the students seeking hostel
                            accommodation for the first time in Non AC Category. In Air conditioned category the
                            security Fee will be 300 USD (Refundable).
                        </p>
                        <p class="text-gray-600  text-sm  my-3 mx-2">
                            <span class="text-gray-800 font-semibold">Note 2</span>
                            All students who are staying in the University Hostel, within the Campus or outside, will
                            have to take food in the mess facility (Veg. or Non-Veg.) provided by the University. No
                            refund application will be entertained once a student occupies a room in the hostel. </p>
                    </div>

                </div>
                <div class="text-justify" *ngIf="pageTitle === 'Admission Rules'">
                    <p class="text-gray-600 my-3">
                        To enroll in ARNI University, Applicants are requested to go through the official website
                        <a class="text-blue-500 underline" href="http://www.arniuniversity.edu.in">www.arniuniversity.edu.in</a>
                        and must read the information carefully, the university will update the information or rules as
                        required.
                    </p>
                    <p class="text-gray-600 my-3">Explore academic courses according to your interests from the
                        range of postgraduate, undergraduate, doctoral, and diploma programs across various schools,
                        including Technology, Business Management & Commerce, Arts & Humanities, Basic Sciences &
                        Bio-Technology, Allied Health Sciences, Pharmacy, Agriculture, Law, Hotel Management & Tourism,
                        and Education & Sports. </p>
                    <p class="text-gray-600 my-3">The eligibility criteria for all international students are a
                        minimum of 50% in the last qualifying exams. A bachelor's degree in a relevant field with a
                        minimum of 55% marks is typically required for postgraduate programs like M.Tech.</p>
                    <p class="text-gray-600 my-3">Once you are satisfied with the course and are eligible,
                        proceed to the registration process. Complete the application form and submit it online. Provide
                        the necessary documents, which may include academic transcripts, certificates, passport copies,
                        and other relevant materials.
                    </p>
                    <p class="text-gray-600 my-3">After submission, the university will review
                        your application and notify you of the admission decision.</p>
                    <p class="text-gray-600 my-3">The university reserves the right to add, withdraw from or
                        change any program or tuition fee
                        without notice or information in this document or otherwise published or announced by the
                        university, and to add, withdraw or change any provision or facility as and when deemed
                        necessary. The university is not responsible and will not accept any liability for any hardship
                        or costs incurred by the applicant or any person(s) in relation to this, regardless of the
                        cause.</p>
                    <p class="text-gray-600 font-bold my-3">Contact Information for International Admissions
                    </p>
                    <p class="text-gray-600 my-3">For personalized guidance and to address any
                        specific queries related to international
                        admissions, please contact:
                    </p>
                    <p class="text-gray-600 my-3 break-words">
                        Email:
                        <a href="mailto:international.admission@arniuniversity.edu.in" class="text-blue-600 hover:underline">
                            international.admission@arniuniversity.edu.in
                        </a>
                    </p>
                    <p class="text-gray-600 my-3 whitespace-nowrap text-sm md:text-lg">Admission Helpline: +2349030848195</p>
                </div>

                <div *ngIf="pageTitle === 'Faqs'">
                    <div class="flex-1 shadow-lg p-4 border-2 border-gray-200 h-fit bg-white text-black aarni-font">
                        <div class="space-y-4">
                            <div *ngFor="let section of admissionFaqs; let i = index">
                                <button class="w-full flex items-center p-6" (click)="toggleAccordion(i)">
                                    <i class="text-lg"
                                       [ngClass]="activeIndex === i ? 'fas fa-minus text-blue-500' : 'fas fa-plus text-blue-500'"></i>
                                    <span
                                        class="ml-2 font-semibold text-start text-lg md:text-xl">{{ section.question }}</span>
                                </button>
                                <div *ngIf="activeIndex === i" class="px-6 pb-2 text-gray-700 text-sm md:text-lg"
                                     [innerHTML]="section.answer"></div>
                                <hr *ngIf="i < admissionFaqs.length - 1">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>


